export default __webpack_public_path__ + "static/media/insta02.fb41aaa1.webp";